//////////////////////////////////////
//1.对齐标注svg.js

//////////////////////////////////////
export function dimAligned(
  group, //标注哪个组group
  points, //标注点坐标[[],[],[]]
  dist1, //尺寸界线偏离起点
  dist2 = dist1 + 800, //尺寸界线偏离终点
  scale_draw = 100, //绘图比例
  scale_print = 100, //出图比例
  isAdjust = true //是否自动调整尺寸线位置
) {
  // 1-0 定义与封装标注组group
  let dimAligned = group
    .group()
    .addClass("dimAligned")
    .stroke({ width: 0.3 * scale_print, color: "green" });

  // 1-1求尺寸界线的方向向量
  let i =
    (points[0][1] - points[1][1]) /
    Math.sqrt(
      (points[0][1] - points[1][1]) ** 2 + (points[1][0] - points[0][0]) ** 2
    );
  let j =
    (points[1][0] - points[0][0]) /
    Math.sqrt(
      (points[0][1] - points[1][1]) ** 2 + (points[1][0] - points[0][0]) ** 2
    );

  let dims = [];
  // 1-2画尺寸界线
  for (let k = 0; k < points.length; k++) {
    let startX = points[k][0] + dist1 * i;
    let startY = points[k][1] + dist1 * j;
    let endX = points[k][0] + dist2 * i;
    let endY = points[k][1] + dist2 * j;
    let midX = points[k][0] + i * (dist2 - 1 * scale_print);
    let midY = points[k][1] + j * (dist2 - 1 * scale_print);
    let arrowX = points[k][0] + i * (dist2 - 2 * scale_print);
    let arrowY = points[k][1] + j * (dist2 - 2 * scale_print);

    dimAligned.line({ x1: startX, y1: startY, x2: endX, y2: endY });
    dimAligned
      .line({ x1: arrowX, y1: arrowY, x2: endX, y2: endY })
      .rotate(45, midX, midY)
      .stroke({ width: 1 * scale_print });
    dims.push([midX, midY]);
  }
  // 1-3画尺寸线及标注
  let flag = 1;
  let value_before,
    value_now = 0;
  // 以下循环标注~~~~~~~~~~~~~~~~~~~~~~~~
  for (let k = 0; k < dims.length - 1; k++) {
    //a画尺寸线
    dimAligned.line({
      x1: dims[k][0],
      y1: dims[k][1],
      x2: dims[k + 1][0],
      y2: dims[k + 1][1],
    });
    //b文字标注
    let x = dims[k + 1][0] - dims[k][0];
    let y = dims[k + 1][1] - dims[k][1];
    value_now =
      Math.round((x ** 2 + y ** 2) ** 0.5) / (scale_print / scale_draw); //绘图比例变换

    if (value_now == 0) {
      value_now = "";
    }
    let dim = dimAligned.text(value_now).font({ size: 3 * scale_print });
    //c文字位置调整
    let dimLength = dim.length();
    let dimAngle = (function () {
      if (x == 0) {
        return 90;
      } else {
        return (Math.atan2(y, x) * 180) / Math.PI;
      }
    })();

    dim
      //c-1文字定位
      .translate(
        (dims[k][0] + dims[k + 1][0]) / 2,
        (dims[k][1] + dims[k + 1][1]) / 2
      );
    //c-2文字旋转
    if (dimAngle > 90) {
      dim.rotate(dimAngle - 180, 0, 0);
    } else if (dimAngle < -90) {
      dim.rotate(dimAngle + 180, 0, 0);
    } else {
      dim.rotate(dimAngle, 0, 0);
    }
    //c-3文字偏离尺寸线
    if (isAdjust == true) {
      if ((value_before + value_now) * (scale_print / scale_draw) < 1200) {
        flag = -flag;
      } else {
        flag = 1;
      }
    }

    if (flag == 1) {
      dim.move(-dimLength / 2, -4 * scale_print);
    } else {
      dim.move(-dimLength / 2, 1 * scale_print);
    }

    value_before = value_now;
  }

  return dimAligned;
}

//////////////////////////////////////
//2.半径标注svg.js
//////////////////////////////////////
export function dimRadius(
  group, //标注哪个组group
  center, //标注点坐标
  r, //标注半径
  offset = 0, //偏移量
  angle, //尺寸界线方向
  scale_print = 100 //比例
) {
  // 1-0 定义与封装标注组group
  let dimRadius = group
    .group()
    .addClass("dimRadius")
    .translate(center[0], center[1])
    .stroke({ width: 0.3 * scale_print, color: "green" })
    .font({ size: 3 * scale_print });

  // 1-1画尺寸界线
  dimRadius.line({
    x1: offset,
    y1: 0,
    x2: r,
    y2: 0,
  });
  // 1-2画箭头
  dimRadius
    .polyline([
      [r, 0],
      [r - 2 * scale_print, -0.35 * scale_print],
      [r - 2 * scale_print, 0.35 * scale_print],
    ])
    .fill("green");
  // 1-3标注文字
  let dim = dimRadius.text(r);
  let dimLength = dim.length();
  dim.move((r + offset) / 2 - dimLength / 2, -4 * scale_print);
  // 1-4标注旋转
  dimRadius.rotate(angle, 0, 0);

  return dimRadius;
}

//////////////////////////////////////
//3.角度标注svg.js
//////////////////////////////////////
export function dimAngle(
  group, //标注哪个组group
  center, //标注点坐标
  r, //标注半径
  angle, //尺寸界线方向
  scale_print = 100 //比例
) {
  // 1-0 定义与封装标注组group
  let dimAngle = group
    .group()
    .addClass("dimAngle")
    .translate(center[0], center[1])
    .stroke({ width: 0.3 * scale_print, color: "green" })
    .font({ size: 3 * scale_print });
  let flag = 1;
  // 1-1画尺寸界线
  let x = r * Math.cos(angle / 180 * Math.PI)
  let y = r * Math.sin(angle / 180 * Math.PI)
  if (angle >= 180) {
    flag = -1
    angle = angle - 360
    dimAngle.path(
      `M ${r} 0 A ${r} ${r} 0 0 0 ${x} ${y} `
    )
  } else {
    dimAngle.path(
      `M ${r} 0 A ${r} ${r} 0 0 1 ${x} ${y} `
    )
  }

  // 1-2画箭头
  dimAngle
    .polyline([
      [r, 0],
      [r - 0.35 * scale_print, 2 * scale_print * flag],
      [r + 0.35 * scale_print, 2 * scale_print * flag],
    ])
    .fill("green")

  dimAngle
    .polyline([
      [r - 0.35 * scale_print, -2 * scale_print * flag],
      [r + 0.35 * scale_print, -2 * scale_print * flag],
      [r, 0],
    ])
    .fill("green")
    .rotate(angle, 0, 0);
  // 1-3标注文字
  let dim = dimAngle.text(`${Math.round(Math.abs(angle))}°`);
  dim.rotate(angle / 2 - 90, 0, 0);
  dim.move(0, r - 4 * scale_print);
  return dimAngle;
}

//////////////////////////////////////
//3.文字标注svg.js
//////////////////////////////////////
export function dimText(
  group, //标注哪个组group
  anchor, //标注点坐标[]
  r, //引出线长度
  angle, //引出线方向(0-360度)
  text, //标注文字['','']
  scale_print = 100 //比例
) {
  // 1-0 定义与封装标注组group
  let dimText = group
    .group()
    .addClass("dimText")
    .translate(anchor[0], anchor[1])
    .font({ size: 3 * scale_print })
    .stroke({ width: 0.3 * scale_print, color: "white" });

  // 1-1画箭头
  dimText
    .polyline([
      [0, 0],
      [2 * scale_print, -0.35 * scale_print],
      [2 * scale_print, 0.35 * scale_print],
    ])
    .fill("white")
    .rotate(angle, 0, 0);
  // 1-2画斜线
  dimText
    .line({
      x1: 0,
      y1: 0,
      x2: r,
      y2: 0,
    })
    .rotate(angle, 0, 0);
  // 1-3标注文字
  let dim = dimText.group();
  let text1 = dim.text(text[0]).move(0, -4 * scale_print);
  let text2 = dim.text(text[1]).move(0, 1 * scale_print);
  let dimLength = Math.max(text1.length(), text2.length());
  if (parseInt(angle) == 90 || parseInt(angle) == 270) {
    dim.move(
      1 * scale_print,
      r * Math.sin((angle / 180) * Math.PI) - 4.5 * scale_print
    );
    dimText.line({
      x1: 0,
      y1: r * Math.sin((angle / 180) * Math.PI),
      x2: 1 * scale_print + dimLength,
      y2: r * Math.sin((angle / 180) * Math.PI),
    });
  } else if (90 < parseInt(angle) && parseInt(angle) < 270) {
    dim.move(
      r * Math.cos((angle / 180) * Math.PI) - 1 * scale_print - dimLength,
      r * Math.sin((angle / 180) * Math.PI) - 4.5 * scale_print
    );
    dimText.line({
      x1: r * Math.cos((angle / 180) * Math.PI),
      y1: r * Math.sin((angle / 180) * Math.PI),
      x2: r * Math.cos((angle / 180) * Math.PI) - 2 * scale_print - dimLength,
      y2: r * Math.sin((angle / 180) * Math.PI),
    });
  } else {
    dim.move(
      r * Math.cos((angle / 180) * Math.PI) + 1 * scale_print,
      r * Math.sin((angle / 180) * Math.PI) - 4.5 * scale_print
    );
    dimText.line({
      x1: r * Math.cos((angle / 180) * Math.PI),
      y1: r * Math.sin((angle / 180) * Math.PI),
      x2: r * Math.cos((angle / 180) * Math.PI) + (2 * scale_print + dimLength),
      y2: r * Math.sin((angle / 180) * Math.PI),
    });
  }

  return dimText;
}

//////////////////////////////////////
//4.文字平行于线的标注svg.js
//////////////////////////////////////
export function dimTextAligned(
  group, //标注哪个组group
  start, //起始点坐标[]
  end, //终止点坐标[]
  text, //标注文字
  lineWidth = 0.3, //线宽
  offset = -4, //偏移量
  scale_print = 100, //比例
  lineColor = "white" //线颜色" //线颜色
) {
  // 1-0 定义与封装标注组group
  let dimTextAligned = group
    .group()
    .addClass("dimTextAligned")
    .translate(start[0], start[1])
    .font({ size: 3 * scale_print });

  // 1-1参数计算
  let x = end[0] - start[0];
  let y = end[1] - start[1];
  let angle = (function () {
    if (x == 0 && y > 0) {
      return 90;
    } else if (x == 0 && y < 0) {
      return 270;
    } else {
      return (Math.atan2(y, x) * 180) / Math.PI;
    }
  })();
  // 1-2画线
  dimTextAligned
    .line({
      x1: 0,
      y1: 0,
      x2: x,
      y2: y,
    })
    .stroke({ width: lineWidth * scale_print, color: lineColor });
  // 1-3标注文字
  let dim = dimTextAligned.text(text);
  let dimLength = dim.length();
  if (parseInt(angle) > 90 || parseInt(angle) < -90) {
    dim
      .rotate(angle - 180, 0, 0)
      .move(
        -Math.sqrt(x ** 2 + y ** 2) / 2 - dimLength / 2,
        offset * scale_print
      );
  } else {
    dim
      .rotate(angle, 0, 0)
      .move(
        Math.sqrt(x ** 2 + y ** 2) / 2 - dimLength / 2,
        offset * scale_print
      );
  }

  return dimTextAligned;
}
//////////////////////////////////////
//5.钢筋编号标注.js
//////////////////////////////////////
// export function dimOneBar(
//   group, //标注哪个组group
//   start, //起始点坐标[]
//   L1, //引出线长度1
//   L2, //引出线长度2
//   angle, //引出线方向(0-360度)
//   num, //钢筋数量
//   grade, //钢筋等级
//   diameter, //钢筋直径
//   space, //钢筋间距
//   No, //钢筋编号
//   lineWidth = 0.3, //线宽
//   offset = -4, //偏移量
//   scale_print = 50 //比例
// ) {
//   // 1-0 定义与封装标注组group
//   let dimOneBar = group
//     .group()
//     .addClass("dimOneBar")
//     .translate(start[0], start[1])
//     .font({ size: 3 * scale_print });

//   // 1-1画线
//   dimOneBar
//     .line({
//       x1: 0,
//       y1: 0,
//       x2: L1,
//       y2: 0,
//     })
//     .stroke({ width: lineWidth * scale_print })
//     .rotate(angle, 0, 0);
//   dimOneBar
//     .line({
//       x1: Math.cos((angle / 180) * Math.PI) * L1,
//       y1: Math.sin((angle / 180) * Math.PI) * L1,
//       x2: Math.cos((angle / 180) * Math.PI) * L1 + L2,
//       y2: Math.sin((angle / 180) * Math.PI) * L1,
//     })
//     .stroke({ width: lineWidth * scale_print })
//     .rotate(angle, 0, 0);
//   // 1-2标注文字

//   return dimOneBar;
// }
